<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        <div class="toolbar">
            <div class="search">
                <i class="fa-light fa-magnifying-glass" aria-hidden="true"></i>
                <input type="text" [(ngModel)]="search" [placeholder]="'files_search_placeholder' | translate" autocomplete="off" />
            </div>
            <button class="add-btn" type="button" (click)="openFileModal()">{{ 'files_add' | translate }}</button>
        </div>

        @if (loading) {
            <p class="state-text">{{ 'admin_loading' | translate }}</p>
        } @else if (files.length === 0) {
            <p class="state-text">{{ 'files_empty' | translate }}</p>
        } @else if (filteredFiles.length === 0) {
            <p class="state-text">{{ 'files_no_match' | translate }}</p>
        } @else {
            <div class="table-wrap">
                <table class="admin-table">
                    <thead>
                        <tr>
                            <th>{{ 'field_title' | translate }}</th>
                            <th>{{ 'field_description' | translate }}</th>
                            <th>{{ 'field_category' | translate }}</th>
                            <th>{{ 'files_table_filename' | translate }}</th>
                            <th class="actions-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (f of filteredFiles; track f.id) {
                            <tr>
                                <td>{{ f.title }}</td>
                                <td class="descr">{{ f.descr }}</td>
                                <td class="category">
                                    @if (f.categoryName) {
                                        <span class="chip">{{ f.categoryName }}</span>
                                    } @else {
                                        <span class="muted">—</span>
                                    }
                                </td>
                                <td class="filename">{{ f.realFilename }}</td>
                                <td class="actions-col">
                                    <button type="button" class="icon-btn download" (click)="download(f)"
                                        [ngbTooltip]="'files_action_download' | translate" container="body">
                                        <fa-icon [icon]="faDownload"></fa-icon>
                                    </button>
                                    <button type="button" class="icon-btn" (click)="openFileModal(f)"
                                        [ngbTooltip]="'admin_action_edit' | translate" container="body">
                                        <fa-icon [icon]="faPen"></fa-icon>
                                    </button>
                                    <button type="button" class="icon-btn danger" (click)="remove(f)"
                                        [ngbTooltip]="'admin_action_delete' | translate" container="body">
                                        <fa-icon [icon]="faTrash"></fa-icon>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>

<app-footer></app-footer>
